"use client"
/* */
const locales = {"de-DE": {  "comboBox.showOptions": `Auswahlmöglichkeiten anzeigen`,
},"en-US": {  "comboBox.showOptions": `Show options`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@51dcf4944c990e2cbe26472300dae78d.mjs.map
